<template>
  <div class="donga-audit">
    <admin-header></admin-header>
    <div class="audit-template admin-template">
      <admin-aside></admin-aside>
      <div class="admin-container">
        <h2 class="contents-tit" style="padding-bottom: 30px; border-bottom:1px solid;">메뉴 그룹권한 관리</h2>
        <section class="admin-contents">
        <div class="card-body">
          <div class="card-body-left">
            <table class="card-table">
              <thead>
                <tr>
                  <th>그룹명</th>
                </tr>
              </thead>
              <tbody>
                <tr class="group-menu-list" v-for="(item, index) in this.getGroupsCombo" v-bind:key="index" @click="goMenu(item)">
                    <td v-bind:class="{ active: isActive == item.code}" >{{ item.title }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body-right">
            <table class="card-table">
              <thead>
                <tr>
                  <th>권한</th>
                  <th>메뉴명</th>
                  <th>URL</th>
                </tr>
              </thead>
              <tr v-if="showMenu === false">
                <td colspan="3">그룹을 선택해주세요.</td>
              </tr>
              <tbody>
                <tr v-for="(item, index) in this.getAdminGroupMenus" v-bind:key="index">
                    <td><input type="checkbox" class="admin-checkbox" name="checkMenu" @click="menuCheck(item)" :checked="item.isMapped" /></td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.url }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </section>
        <div style="clear:both;"></div>
      </div>
    </div>
    <admin-footer></admin-footer>
  </div>
</template>

<style lang="scss" scoped>
@import '../css/sub.scss';
@import '../css/admin.scss';
.group-menu-list{
  td{
    &.active{
    background:#4174ff;
    color: #fff;
    border-left: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
   }
  }
}

</style>

<script>
import AdminHeader from '@/components/AdminHeader'
import AdminFooter from '@/components/AdminFooter'
import AdminAside from '@/components/AdminAside'
import Modal from '@/components/AdminModal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdminGroupAuth',
  components: {
    'admin-footer': AdminFooter,
    'admin-header': AdminHeader,
    'admin-aside': AdminAside,
    'modal': Modal
  },
  data () {
    return {
      groupId: '',
      groupName: '',
      showMenu: false,
      isActive: ''
    }
  },
  created () {
    this.setInit()
  },
  methods: {
    ...mapActions({
      setInit: 'apiSysadminGroupsCombo'
    }),
    goMenu (item) {
      this.$store.dispatch('apiSysadminGroupMenus', {'groupId': item.code, 'method': 'GET'})
      this.showMenu = true
      this.groupId = item.code
      this.isActive = item.code
      this.groupName = item.title
    },
    menuCheck (item) {
      if (item.isMapped === false) {
        const params = {
          'menu_id': item.menuId,
          'user_group_id': this.groupId,
          'method': 'POST'
        }
        this.$store.dispatch('apiSysadminGroupMenus', params)
      } else {
        const params = {
          'group_menu_id': item.groupMenuId,
          'user_group_id': this.groupId,
          'method': 'DELETE'
        }
        this.$store.dispatch('apiSysadminGroupMenus', params)
      }
    }
  },
  computed: {
    ...mapGetters(['getAdminGroupMenus', 'getGroupsCombo'])
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/AdminGroupAuth.vue